import { Box, Grid } from "@mui/material";
import CommonDialog from "../../common/commonDialog";
import { Button, Card, CardBody } from "reactstrap";
import { Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { formatMoney } from "../../../constants/utils";
import moment from "moment";
import CollapsibleTableForHistory from "./CollapsibleTableForHistory";

const AgeingReportHistoryModal = (props) => {
  const { open, onCancel, modalData, title } = props;
  const [showDetailedView, setShowDetailedView] = useState(false);
  return (
    <CommonDialog
      onCancel={onCancel}
      open={open}
      secondaryButtonLabel={"Cancel"}
      title={title}
      maxWidth="lg"
    >
      <Grid container spacing={2}>
        <Col lg={12} xs={12}>
          <Card className="height-equal">
            <CardBody style={{ padding: "2px" }}>
              <Box display={"flex"}>
                <Button
                  style={{ marginLeft: 10, marginBottom: 4, width: 250 }}
                  color="dark"
                  variant="contained"
                  type="button"
                  onClick={() => setShowDetailedView(!showDetailedView)}
                >
                  {`View ${!showDetailedView ? "Detailed" : "Main"} data`}
                </Button>
              </Box>
              <CollapsibleTableForHistory
                modalData={modalData}
                showDetailedView={showDetailedView}
              />
              {/*  <div className="user-status table-responsive text-center">
                <table className="table table-bordernone mb-0 mt-10">
                  <thead>
                    <tr>
                      <th scope="col">SNO</th>
                      <th scope="col">Customer</th>
                      <th scope="col">Customer Code</th>
                      <th scope="col">Created Date</th>
                      <th scope="col">Net Balance</th>
                      <th scope="col">Over due</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modalData
                      .filter((item) => item.netBalance > 0)
                      .map((data, index) => (
                        <tr key={data.customerCode}>
                          <td>{index + 1}</td>

                          <td>{data.customerName}</td>
                          <td>{data.customerCode}</td>
                          <td>
                            {moment(data.createdDate).format("MMMM YYYY")}
                          </td>

                          <td>{formatMoney(data.netBalance?.toFixed(0))}</td>
                          <td>{formatMoney(data.overdue?.toFixed(0))}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div> */}
            </CardBody>
          </Card>
        </Col>
      </Grid>
    </CommonDialog>
  );
};
export default AgeingReportHistoryModal;
